import { createRouter } from "@tanstack/react-router";
import type { AuthContext } from "@/contexts/auth";
import { routeTree } from "@/routeTree.gen";

export const router = createRouter({
  routeTree,
  context: {
    auth: {
      isAuthenticated: false,
      login: () => {
        throw new Error("Not implemented");
      },
      logout: () => {
        throw new Error("Not implemented");
      },
    },
  },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface RouterContext {
    auth: AuthContext;
  }
}
